<template>
  <div>
    <b-alert
      :show="bilgiBarGoster"
      class="bilgi-bar"
    >
      <div class="d-flex align-items-start">
        <b-icon icon="info-circle-fill" class="bilgi-bar-icon" />
        <div>
          <strong>Bu sayfada neler değişti?</strong>
          <ul class="bilgi-bar-list">
            <li>
              Pazaryeri seçip <strong>Sipariş Çek</strong>'e bastığınızda siparişler
              otomatik olarak kontrol edilip listelenir. (Sipariş çek, sipariş listele ve sipariş kontrol işlemleri tek bir buton ile yapılır.)
            </li>
            <li>
              Tamamlanan siparişleri de görmek için <strong>Tüm Siparişleri Listele</strong>,
              muhasebe programına aktarmak için <strong>Sipariş Kaydet</strong> butonlarını
              kullanabilirsiniz.
            </li>
          </ul>
        </div>
      </div>
    </b-alert>

    <vs-card>
      <b-row>
        <b-col cols="4">
          <div class="d-flex align-center">
            <v-select
              v-model="Merb"
              :options="tabmenus"
              placeholder="Pazaryeri Seçiniz"
              label="name"
              class="custom-select"
            >
              <template slot="option" slot-scope="option">
                <img
                  v-if="mpControl(option.name)"
                  :src="
                    getLogoUrl(option.name)
                  "
                  width="30"
                  v-b-tooltip.hover.bottom="option.name"
                  @error="errorImage"
                />

                {{ option.name }}
              </template>
            </v-select>
          </div>
        </b-col>

        <b-col>
          <div class="d-flex justify-content-end mr-16" style="gap: 50px">
            <vs-button
              style="padding: 0.679rem 0.7rem"
              size="default"
              line-position="top"
              line-origin="right"
              color="#7a4ce6"
              type="border"
              @click="siparisCek(0)"
              id="button-with-loading-cek"
              class="vs-con-loading__container"
            >
              <b-iconstack font-scale="1">
                <b-icon icon="arrow-bar-down" />
              </b-iconstack>
              Sipariş Çek
            </vs-button>
            <vs-button
              style="padding: 0.679rem 0.7rem"
              size="default"
              line-position="top"
              line-origin="right"
              color="#7a4ce6"
              type="border"
              @click="activePromptStockUpdate = true"
              id="button-with-loading-kaydet"
              class="vs-con-loading__container"
            >
              <b-iconstack font-scale="1">
                <b-icon icon="arrow-bar-down" />
              </b-iconstack>
              Sipariş Kaydet
            </vs-button>
            <vs-button
              style="padding: 0.679rem 0.7rem"
              size="default"
              line-position="top"
              line-origin="right"
              color="#7a4ce6"
              type="border"
              @click="activePrompt = true"
              id="button-with-loading-partile"
              class="vs-con-loading__container"
            >
              <b-iconstack font-scale="1">
                <b-icon icon="arrow-bar-down" />
              </b-iconstack>
              Partile
            </vs-button>
            <vs-button
              style="padding: 0.679rem 0.7rem"
              size="default"
              line-position="top"
              line-origin="right"
              color="#7a4ce6"
              type="border"
              @click="siparisListesi()"
              id="button-with-loading-listele"
              class="vs-con-loading__container"
            >
              <b-iconstack font-scale="1">
                <b-icon icon="list-ul" />
              </b-iconstack>
              Tüm Siparişleri Listele
            </vs-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="arananDeger"
              id="smallInput"
              placeholder="Ara.."
              @keyup.enter="siparisListesi"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </vs-card>

    <!-- Ag-Grid bileşeni -->
    <ag-grid-vue
      :defaultColDef="defaultColDef"
      style="width: 100%; height: 400px; margin-top: 50px;"
      class="ag-theme-alpine"
      :rowData="list"
      :columnDefs="columnDefs"
      :getRowStyle="getRowStyle"
      :rowSelection="rowSelection"
      @grid-ready="onGridReady"
      @cell-editing-stopped="onCellValueChanged"
      :suppressCopyRowsToClipboard="true"
      :undoRedoCellEditing="true"
      :pagination="true"
    ></ag-grid-vue>
    <invoice :invoiceData="invoiceData" :popupActivo="popupActivo"></invoice>
    <LogList :logOrderNumber="logOrderNumber" :module="'Order'" ref="getLogList" />
    <vs-prompt
      color="warning"
      :title="warningText"
      acceptText="Gönder"
      cancelText="Vazgeç"
      @accept="siparisKaydet()"
      :active.sync="activePromptStockUpdate"
    >
    </vs-prompt>
    <vs-prompt
      color="warning"
      title="Siparişi güncellemek istediğinize emin misiniz?"
      acceptText="Güncelle"
      cancelText="Vazgeç"
      @accept="siparisGuncelle()"
      @cancel="siparisVazgec()"
      :active.sync="activePromptStockGuncelle"
    >
    </vs-prompt>
    <vs-prompt
      title="Partileme İşlemleri"
      acceptText="İşlemi Başlat"
      cancelText="Vazgeç"
      @accept="partilemeyiBaslat"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        <span>Partileme Miktarı</span>
        <vs-input
          type="number"
          placeholder="Sayı Giriniz"
          vs-placeholder="Code"
          v-model="partiVal"
          class="mt-3 w-full"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import invoice from "./CellRenderers/invoice.vue";
import LogList from "../components/uzum-components/LogList.vue";
import vSelect from "vue-select";
import Store from "../../store/store";
import state from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import ActionsCellRenderer from "./CellRenderers/ActionCellRenderer.vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";

export default {
  data() {
    return {
      arananDeger: "",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: [],
      warningText: "Siparişler muhasebenize aktarılacak. Emin misiniz!",
      activePromptStockUpdate: false,
      activePromptStockGuncelle: false,
      activePrompt: false,
      partiVal: "",
      popupActivo: false,
      invoiceData: null,
      logOrderNumber: "",
      gridApi: null,
      rowSelection: null,
      activeListMode: "listele",
      // Sayfadaki yeniliklerin anlatıldığı bilgilendirme barının görünürlüğü
      bilgiBarGoster: true,
      tabmenus: null,
      Merb: null,
      list: [],
    };
  },

  methods: {
    siparisVazgec() {
      this.gridApi.undoCellEditing();
    },
    siparisGuncelle() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = Store.state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: vm.selecedForUpdate.data.program,
        invoiceName: vm.selecedForUpdate.data.invoiceFirstName,
        invoiceLastName: vm.selecedForUpdate.data.invoiceLastName,
        shipFullAddress: vm.selecedForUpdate.data.shipFullAddress,
        shipFullName: vm.selecedForUpdate.data.shipFullName,
        invoiceAddress1: vm.selecedForUpdate.data.invoiceAddress1,
        invoiceAddress2: vm.selecedForUpdate.data.invoiceAddress2,
        invoiceCitycode: vm.selecedForUpdate.data.invoiceCitycode,
        invoiceDistrict: vm.selecedForUpdate.data.invoiceDistrict,
        invoiceCountryCode: vm.selecedForUpdate.data.invoiceCountryCode,
        invoiceDistrictId: vm.selecedForUpdate.data.invoiceDistrictId,
        invoiceFullAddress: vm.selecedForUpdate.data.invoiceFullAddress,
        invoiceFullName: vm.selecedForUpdate.data.invoiceFullName,
        invoiceCompany: vm.selecedForUpdate.data.invoiceCompany,
        invoiceCity: vm.selecedForUpdate.data.invoiceCity,
        invoiceCityCode: vm.selecedForUpdate.data.invoiceCityCode,
        invoicePostalCode: vm.selecedForUpdate.data.invoicePostalCode,
        telefon: vm.selecedForUpdate.data.telefon,
        taxOffice: vm.selecedForUpdate.data.taxOffice,
        taxnumber: vm.selecedForUpdate.data.taxNumber,
        tcIdentityNumber: vm.selecedForUpdate.data.tcIdentityNumber,
        shipFirstName: vm.selecedForUpdate.data.shipFirstName,
        shipLastName: vm.selecedForUpdate.data.shipLastName,
        shipCity: vm.selecedForUpdate.data.shipCity,
        shipCityCode: vm.selecedForUpdate.data.shipCityCode,
        shipCountryCode: vm.selecedForUpdate.data.shipCountryCode,
        shipDistirict: vm.selecedForUpdate.data.shipDistirict,
        shipPostalCode: vm.selecedForUpdate.data.shipPostalCode,
        shipAdress1: vm.selecedForUpdate.data.shipAddress1,
        shipAdress2: vm.selecedForUpdate.data.shipAddress2,
        orderNumber: vm.selecedForUpdate.data.orderNumber,
        merchantSku: vm.selecedForUpdate.data.merchantSku,
        cargoTrackingNumber: vm.selecedForUpdate.data.cargoTrackingNumber,
      };
      try {
        soap.createClient(url, function (err, client) {
          client.UzumSiparisGuncelle(args, function (err, result) {
            if (result.UzumSiparisGuncelleResult == "-1") {
              Store.dispatch("logout");
            }
            vm.veriler = JSON.parse(result.UzumSiparisGuncelleResult);
            vm.refreshAktifListe();
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    refreshAktifListe() {
      if (this.activeListMode === "kontrol") {
        this.siparisKontrol();
      } else {
        this.siparisListesi();
      }
    },
    onCellValueChanged(params) {
      this.selecedForUpdate = params;
      this.activePromptStockGuncelle = true;
    },
    partilemeyiBaslat() {
      const vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = Store.state.sistemAddress;
      const selectedPazaryeri = this.Merb;
      if (selectedPazaryeri) {
        if (vm.partiVal != null || vm.partiVal != "") {
          const args = {
            pazaryeri: vm.Merb.name,
            parti: vm.partiVal,
            token: Store.state.tokenId,
          };

          vs.loading({
            background: "#6e048a",
            container: "#button-with-loading-partile",
            scale: 0.45,
          });
          try {
            soap.createClient(url, function (err, client) {
              client.partile(args, function (err, result) {
                if (result.partileResult == "-1") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }

                try {
                  vm.veriler = JSON.parse(result.partileResult);
                  if (vm.veriler.response == "Ok") {
                    vs.loading.close("#button-with-loading-partile > .con-vs-loading");
                    vs.notify({
                      title: "Partileme",
                      text: "Partileme İşlemi Başarılı",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "success",
                      position: "top-center",
                    });
                  } else {
                    vs.notify({
                      title: "Partileme",
                      text: "Partilemede Hata Oluştu",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                      position: "top-center",
                    });
                  }
                } catch (error) {
                  vs.loading.close("#button-with-loading-partile > .con-vs-loading");
                  vs.notify({
                    title: "Partileme",
                    text: "Partilemede Hata Oluştu",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              });
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          vs.notify({
            text: "Parti numarası seçiniz",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      } else {
        console.warn("Lütfen bir pazaryeri seçin");
        vs.notify({
          title: "",
          text: "Lütfen bir pazaryeri seçin",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
    deleteOrderAll(data) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = Store.state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: data.program,
        orderNumber: data.orderNumber,
      };

      try {
        soap.createClient(url, function (err, client) {
          client.pazaryeriSiparisSil(args, function (err, result) {
            if (result.pazaryeriSiparisSilResult == "-1") {
              Store.dispatch("logout");
            }
            vm.veriler = JSON.parse(result.pazaryeriSiparisSilResult);
            vm.refreshAktifListe();
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    returnOrder(data) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = Store.state.sistemAddress;
      const args = {
        orderNumber: data.orderNumber,
      };
      try {
        soap.createClient(url, function (err, client) {
          client.siparisGeriAl(args, function (err, result) {
           
            vm.veriler = JSON.parse(result.siparisGeriAlResult);
            vm.refreshAktifListe();
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    closePopupAction(flag) {
      this.popupActivo = false;
    },
    invoiceButtonClick(value) {
      this.popupActivo = true;
      this.invoiceData = value;
    },
    mpControl(e) {
      if (
        !e.includes("Toplu") &&
        !e.includes("Flip") &&
        !e.includes("Php") &&
        !e.includes("Tümü")
      )
        return true;
      else return false;
    },
    getLogoName(name) {
      const trimmed = (name || "").trim();
      if (trimmed === "Trendyol") {
        return "trendyol";
      }
      if (trimmed === "Hepsiburada") {
        return "hepsiburada";
      }
      return trimmed;
    },
    getLogoUrl(name) {
      const logoName = this.getLogoName(name);
      console.log(logoName);
      
      if (!logoName) {
        return null;
      }
      try {
        return require(`../../assets/images/logo/${logoName}.png`);
      } catch (error) {
        return null;
      }
    },
    errorImage(e) {
      if (e.type == "error")
        e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg";
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getRowStyle(params) {
      if (params.data && params.data.iscomplete === "completed") {
        return { background: "rgb(202, 250, 216)" };
      } else {
        return { background: "" };
      }
    },
    siparisCek(sayfasayisi) {
      const selectedPazaryeri = this.Merb;
      var vs = this.$vs;

      if (selectedPazaryeri) {
        let type = "radius";
        vs.loading({
          container: "#button-with-loading-cek",
          type,
        });
        var vm = this;
        let args = {};
        args = {
          pazaryeri: vm.Merb.name,
          siparisDurumu: 0,
          listelenecekSayfa: sayfasayisi,
          token: Store.state.tokenId,
        };
        const soap = require("soap");
        const url = Store.state.sistemAddress;
        soap.createClient(url, function (err, client) {
          client.pazaryeriSiparisCek(args, function (err, result) {
            if (result.pazaryeriSiparisCekResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.pazaryeriSiparisCekResult);
              if (vm.veriler.response == "Ok") {
                vs.loading.close("#button-with-loading-cek > .con-vs-loading");

                vs.notify({
                  title: "",
                  text: "Siparişler Çekildi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                vm.siparisKontrol();
              } else {
                vs.loading.close("#button-with-loading-cek > .con-vs-loading");
                vs.notify({
                  title: "",
                  text: result,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            } catch (error) {
              vs.loading.close("#button-with-loading-cek > .con-vs-loading");
              vs.notify({
                title: "",
                text: error,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
      } else {
        console.warn("Lütfen bir pazaryeri seçin");
        vs.notify({
          title: "",
          text: "Lütfen bir pazaryeri seçin",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
    // "dd.MM.yyyy HH:mm:ss" formatındaki tarihi Date nesnesine çevirir
    parseSiparisTarihi(value) {
      if (!value || typeof value !== "string") return null;
      const match = value
        .trim()
        .match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/);
      if (!match) return null;
      const [, gun, ay, yil, saat = 0, dakika = 0, saniye = 0] = match;
      return new Date(yil, ay - 1, gun, saat, dakika, saniye);
    },
    siparisTarihiColumnDef(val) {
      const vm = this;
      const zaman = (value) => {
        const tarih = vm.parseSiparisTarihi(value);
        return tarih ? tarih.getTime() : null;
      };
      return {
        headerName: vm.$t(val),
        field: val,
        filter: "agDateColumnFilter",
        wrapText: true,
        autoHeight: true,
        editable: true,
        cellRenderer: "TextGorunumCellRenderer",
        comparator: (a, b) => {
          const ta = zaman(a);
          const tb = zaman(b);
          if (ta === null && tb === null) return 0;
          if (ta === null) return -1;
          if (tb === null) return 1;
          return ta - tb;
        },
        filterParams: {
          buttons: ["apply", "reset"],
          closeOnApply: true,
          comparator: (filterDate, cellValue) => {
            const tarih = vm.parseSiparisTarihi(cellValue);
            if (!tarih) return -1;
            const gun = new Date(tarih.getFullYear(), tarih.getMonth(), tarih.getDate());
            if (gun < filterDate) return -1;
            if (gun > filterDate) return 1;
            return 0;
          },
        },
      };
    },
    buildColumnDefs(columnList, options = {}) {
      const { programWidth = 100, editablePinned = false } = options;
      const vm = this;

      const columnDefs = [
        {
          pinned: "left",
          width: 150,
          filter: "agNumberColumnFilter",
          filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
          cellRenderer: "ActionsCellRenderer",
        },
      ];

      columnList.forEach((val) => {
        if (val == "program") {
          columnDefs.push({
            width: programWidth,
            headerName: "Pazaryeri",
            field: "program",
            sortable: true,
            filter: "agSetColumnFilter",
            pinned: "left",
            filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
            cellRenderer: (params) => {
              const logoURL = vm.getLogoUrl(params.value);
              return logoURL
                ? `<img src="${logoURL}" alt="Image Description" height="30" style="margin-left: 10px;" />`
                : "";
            },
          });
        } else if (
          val == "orderNumber" ||
          val == "merchantSku" ||
          val == "quantity" ||
          val == "invoiceFullName"
        ) {
          columnDefs.push({
            headerName: vm.$t(val),
            field: val,
            sortable: true,
            filter: "agSetColumnFilter",
            pinned: "left",
            editable: editablePinned,
            filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
          });
        } else if (val == "siparisTarihi") {
          columnDefs.push(vm.siparisTarihiColumnDef(val));
        } else {
          columnDefs.push({
            headerName: vm.$t(val),
            field: val,
            filter: "agSetColumnFilter",
            wrapText: true,
            autoHeight: true,
            editable: true,
            cellRenderer: "TextGorunumCellRenderer",
          });
        }
      });

      return columnDefs;
    },
    siparisListesi() {
      const selectedPazaryeri = this.Merb;
      var vs = this.$vs;

      if (selectedPazaryeri) {
        let type = "radius";
        vs.loading({
          container: "#button-with-loading-listele",
          type,
        });

        var vm = this;
        vm.activeListMode = "listele";
        vm.columnDefs = [];
        const soap = require("soap");
        const url = Store.state.sistemAddress;
        const args = {
          pazaryeri: selectedPazaryeri.name === "Tümü" ? null : selectedPazaryeri.name,
          grupla: "true",
          token: Store.state.tokenId,
          aranan: this.arananDeger && this.arananDeger.trim() !== "" ? this.arananDeger : null
        };

        soap.createClient(url, function (err, client) {
          client.siparisListeleToplu(args, function (err, result) {
            if (result.siparisListeleTopluResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vs.loading.close("#button-with-loading-listele > .con-vs-loading");
              vm.veriler = JSON.parse(result.siparisListeleTopluResult);

              // vm.toplamSayfa = vm.veriler[0]["toplamKayitSayisi"];
              vm.tamamlananList = vm.veriler;
              // Sipariş verilerini list adlı veri öğesine atandı
              const siparisVerileri = vm.veriler.jsonData; // Sipariş verilerini çıkarın
              vm.list = siparisVerileri; // Verileri list öğesine atanıyo

              vm.columnDefs = vm.buildColumnDefs(Object.keys(vm.list[0]), {
                programWidth: 80,
                editablePinned: true,
              });
            } catch (error) {
              console.log(error);
              vs.loading.close("#button-with-loading-listele > .con-vs-loading");
              vs.notify({
                title: "",
                text: "Siparişler listelenirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
      } else {
        vs.notify({
          title: "",
          text: "Lütfen bir pazaryeri seçin",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
    siparisKontrol() {
      var vs = this.$vs;
      const selectedPazaryeri = this.Merb;
      if (selectedPazaryeri) {
        this.siparisKontrolBasildimi = 1;
        this.activeListMode = "kontrol";
        const vm = this;
        vm.columnDefs = [];

        let type = "radius";
        vs.loading({
          container: "#button-with-loading-cek",
          type,
        });

        const soap = require("soap");
        const url = Store.state.sistemAddress;
        const args = { program: this.Merb.name, token: Store.state.tokenId };

        soap.createClient(url, function (err, client) {
          client.siparisKontrol(args, function (err, result) {
            if (result.siparisKontrolResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.siparisKontrolResult);
              console.log(vm.veriler);
              vm.list = vm.veriler;
              if (vm.veriler.length > 0) {
                let columnList = Object.keys(vm.list[0]);

                //   vm.generateColumnDefs(vm.list);

                vm.columnDefs.push({
                  pinned: "left",
                  width: 150,

                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
                  cellRenderer: "ActionsCellRenderer",
                });
                columnList.forEach((val, index) => {
                  if (val == "program") {
                    vm.columnDefs.push({
                      width: 100,
                      headerName: "Pazaryeri",
                      field: "program",
                      sortable: true,
                      filter: "agSetColumnFilter",
                      pinned: "left",
                      filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
                      cellRenderer: (params) => {
                        const program = params.value; // program değerini alıyo

                        let logoURL = ""; // varsayılan olarak boş URL

                        logoURL = vm.getLogoUrl(program);

                        if (logoURL) {
                          return `<img src="${logoURL}" alt="Image Description"  height="30" style="margin-left: 10px;" />`;
                        } else {
                          return "";
                        }
                      },
                    });
                  } else if (
                    val == "orderNumber" ||
                    val == "merchantSku" ||
                    val == "quantity" ||
                    val == "invoiceFullName"
                  ) {
                    vm.columnDefs.push({
                      headerName: vm.$t(val),
                      field: val,
                      sortable: true,
                      filter: "agSetColumnFilter",
                      pinned: "left",

                      filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
                    });
                  } else if (val == "siparisTarihi") {
                    vm.columnDefs.push(vm.siparisTarihiColumnDef(val));
                  } else
                    vm.columnDefs.push({
                      headerName: vm.$t(val),
                      field: val,
                      filter: "agSetColumnFilter",
                      wrapText: true,
                      autoHeight: true,
                      editable: true,
                      cellRenderer: "TextGorunumCellRenderer",
                    });
                });
              }

              vs.loading.close("#button-with-loading-cek > .con-vs-loading");
              vs.notify({
                title: "",
                text: "Siparişler Kontrol Edildi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } catch (error) {
              vs.loading.close("#button-with-loading-cek > .con-vs-loading");

              vs.notify({
                title: "",
                text: "Siparişler Kontrol Edilirken Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
      } else {
        vs.notify({
          title: "",
          text: "Lütfen bir pazaryeri seçin",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
    siparisKaydet() {
      var vs = this.$vs;

      const selectedPazaryeri = this.Merb;
      if (selectedPazaryeri) {
        if (this.siparisKontrolBasildimi == 1) {
          let type = "radius";
          vs.loading({
            container: "#button-with-loading-kaydet",
            type,
          });

          var vm = this;

          const soap = require("soap");
          const url = Store.state.sistemAddress;
          const args = {
            program: this.Merb.name,
            sayfa: this.siparisKaydetSayi,
            token: Store.state.tokenId,
            EMPLOYEEID: Store.state.plasiyer,
          };
          soap.createClient(url, function (err, client) {
            client.siparisKaydet(args, function (err, result) {
              if (result.siparisKaydetResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }

              try {
                vs.loading.close("#button-with-loading-kaydet > .con-vs-loading");

                vm.veriler = JSON.parse(result.siparisKaydetResult);

                if (
                  vm.veriler &&
                  vm.veriler.error === "Yes" &&
                  typeof vm.veriler.message === "string"
                ) {
                  if (vm.veriler.message.includes("Incorrect syntax near 'kod'")) {
                    vs.notify({
                      title: "Sipariş Kaydet",
                      text: "Vergi dairenizi kontrol edin.",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "warning",
                      position: "top-center",
                    });
                  } else if (vm.veriler.message.includes("There is no row at position 0")) {
                    vs.notify({
                      title: "Sipariş Kaydet",
                      text: "Ürün muhasebe programında bulunmuyor.",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "warning",
                      position: "top-center",
                    });
                  } else if (vm.veriler.message.includes("Incorrect syntax near 'sehiradi'")) {
                    vs.notify({
                      title: "Sipariş Kaydet",
                      text: "Şehir adını kontrol edin.",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "warning",
                      position: "top-center",
                    });
                  }
                }

                if (vm.veriler.response == "Bitti") {
                  vm.siparisKontrol();
                }
              } catch (error) {
                vs.loading.close("#button-with-loading-kaydet > .con-vs-loading");

                vs.notify({
                  title: "Sipariş Kaydet",
                  text: "Sipariş Kaydederken Hata Oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            });
          });
        } else {
          vs.notify({
            title: "Sipariş Kayıt",
            text: "Siparişi Kaydetmeden Önce Sipariş Çek Butonuna Basınız",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      } else {
        vs.notify({
          title: "",
          text: "Lütfen bir pazaryeri seçin",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
  },
  components: {
    "v-select": vSelect,
    "ag-grid-vue": AgGridVue, // AG-Grid bileşeni
    ActionsCellRenderer,
    LogList,
    invoice,
    TextGorunumCellRenderer,
  },

  mounted() {
    this.$root.$on("deleteOrderAll", (data) => {
      this.deleteOrderAll(data);
    });
    this.$root.$on("returnOrder", (data) => {
      this.returnOrder(data);
    });
    this.$root.$on("orderLogList", (data) => {
      this.$refs.getLogList.getLogList(data.orderNumber);
    });
    this.$root.$on("invoiceButtonClick", (params) => {
      this.invoiceButtonClick(params);
    });
    this.$root.$on("closePopupAction", (params) => {
      this.closePopupAction(params);
    });
  },
  beforeDestroy() {
    this.$root.$off("orderLogList");
    this.$root.$off("invoiceButtonClick");
    this.$root.$off("closePopupAction");
    this.$root.$off("deleteOrderAll");
    this.$root.$off("returnOrder");
  },
  created() {
    this.tabmenus = [];
    this.tabmenus.push({ name: "Tümü" });
    let moduller = JSON.parse(Store.state.moduller);
    moduller.forEach((val, index) => {
      this.tabmenus.push({ name: val.marketplace });
    });
    this.rowSelection = "single";
  },
};
</script>

<style lang="scss" scoped>
.bilgi-bar {
  background-color: #f3eefd;
  border: 1px solid #7a4ce6;
  border-left: 4px solid #7a4ce6;
  color: #412085;
  border-radius: 6px;
}

.bilgi-bar-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 2px;
  color: #7a4ce6;
}

.bilgi-bar-list {
  margin: 6px 0 0;
  padding-left: 18px;

  li {
    margin-bottom: 4px;
  }
}

.custom-select {
  width: 300px;
}

button {
  background-color: #7a4ce6;
  color: #1a1c9f;
}

button:hover {
  background-color: #5c359f;
  color: #76127d;
}
</style>
